import CoreLoader from '@components/CoreLoader'
import { breakpoints } from '@constants'
import { useMenuItems } from '@hooks'
import MenuIcon from '@images/icons/menu-collapse-icon.svg?react'
import MenuCollapsedIcon from '@images/icons/the-kingdom-bank-collapsed-logo.svg'
import LogoImage from '@images/icons/the-kingdom-bank-logo.svg?react'
import OnboardingBanner from '@onboarding/views/OnboardingBanner'
import cn from 'classnames'
import { paths, useMerchantAccounts } from 'mmfintech-backend-api'
import { tr, useMatchMedia } from 'mmfintech-commons'
import { useEffect, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'

import './coreMenu.scss'

export const CoreMenu = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false)

  const history = useHistory()

  const { accountsFetching } = useMerchantAccounts()

  const autoCollapse = useMatchMedia({
    breakpoint: breakpoints.MENU_CLOSE_WIDTH,
    prefix: 'max'
  })

  const menuItems = useMenuItems()

  useEffect(() => {
    setCollapsed(autoCollapse)
  }, [autoCollapse])

  return (
    <div className='core-menu'>
      <div className={cn('core-menu-wrapper', { collapsed })}>
        <div style={{ width: '100%' }}>
          <div className='menu-header'>
            <MenuIcon
              data-test='menu-header-collapse-icon'
              className='collapse-icon'
              onClick={() => setCollapsed(!collapsed)}
            />
            {collapsed ? (
              <img
                data-test='menu-header-image'
                className='menu-logo'
                onClick={() => history.push(paths.dashboard())}
                src={MenuCollapsedIcon}
                alt={tr('FRONTEND.CORE_MENU.MISSING_LOGO', 'missing logo')}
              />
            ) : (
              <LogoImage
                data-test='menu-header-image'
                className='menu-logo'
                onClick={() => history.push(paths.dashboard())}
              />
            )}
          </div>

          {accountsFetching ? (
            <CoreLoader />
          ) : (
            <ul className='menu-body'>
              {menuItems.map(({ label, path, icon: Icon, localization, toolTip, onClick }) => {
                return (
                  <li key={label} className='button-wrapper'>
                    <NavLink
                      data-for={`side-menu${toolTip}`}
                      data-tip={tr(localization, label)}
                      data-test={`menu-links-${label}`}
                      to={path ?? '#'}
                      onClick={e => {
                        if (!path) {
                          e.preventDefault()
                        }
                        onClick?.()
                      }}
                      className='menu-item-wrapper'
                    >
                      <Icon />
                      <span data-test={`menu-links-label-${label}`} className='menu-item'>
                        {tr(localization, label)}
                      </span>
                    </NavLink>
                    <ReactTooltip
                      id={`side-menu${toolTip}`}
                      textColor='black'
                      backgroundColor='white'
                      effect='solid'
                      className='custom-tool-tip-component'
                      padding='8px 6px'
                      place={'right'}
                      disable={!collapsed}
                    >
                      {toolTip}
                    </ReactTooltip>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
        <div className='menu-bottom-section'>
          <div className='menu-onboarding-banner-wrapper'>
            <OnboardingBanner collapsed={collapsed} />
          </div>
        </div>
      </div>
    </div>
  )
}
